<template>
    <div class="cgs-app-staging">
        <van-search placeholder="全局搜索" @focus='goToSearch' />
        <div class="fastEntryContainer">
            <!-- <van-button type="primary" round v-for="item in fastEntryList" :key="item.id" @click="clickFastEntry(item)">签到</van-button> -->
            <!-- <van-collapse v-model="activeNames">
            <van-collapse-item title="标题1" name="1">内容</van-collapse-item>
            <van-collapse-item title="标题2" name="2">内容</van-collapse-item>
            <van-collapse-item title="标题3" name="3">内容</van-collapse-item>
            </van-collapse> -->
        </div>
        <van-pull-refresh v-model="wholeLoading" @refresh="onRefresh" class="stagingCollapseRefresh">
            <van-collapse v-model="activeNames" @change="collapseChange" :border="false" class="stagingCollapse">
                <van-collapse-item title="快捷入口" name="fastEntry" v-show="fastEntryShow && fastEntryList.length > 0">
                    <van-button type="primary" round v-for="item in fastEntryList" :key="item.id"
                        @click="clickFastEntry(item)" style="margin: 0px 10px 10px 0px;">{{ item.label }}</van-button>
                </van-collapse-item>
                <van-collapse-item title="默认" name="default" v-show="mapGroupApp['default'] && mapGroupApp['default'].length > 0">
                    <van-grid square :border="false" :clickable="true"
                        v-if="activeNames.indexOf('default') !== -1 && mapGroupApp['default'] !== undefined">
                        <van-grid-item v-for="item in mapGroupApp['default']" :key="item.id" icon="photo-o"
                            :text="item.title" @click="clickApp(item)">
                            <template #icon>
                                <div class="stagingIconContainer" :class="item.theme ? item.theme : 'defaultTheme'">
                                    <van-icon class-prefix="logoIcon" :name="item.icon ? item.icon : defaultLogoIcon"
                                        class="app-staging-icon" :class="logoIconFontFamily" />
                                </div>
                            </template>
                        </van-grid-item>
                    </van-grid>
                    <span v-if="mapGroupApp['default'] !== undefined && mapGroupApp['default'].length === 0">无</span>
                </van-collapse-item>
                <van-collapse-item :title="group.categoryKey" :name="group.categoryValue" v-for="group in groupList"
                    v-show="mapGroupApp[group.categoryValue] && mapGroupApp[group.categoryValue].length > 0"
                    :key="group.id">
                    <van-grid square :border="false" :clickable="true"
                        v-if="activeNames.indexOf(group.categoryValue) !== -1 && mapGroupApp[group.categoryValue] !== undefined">
                        <van-grid-item v-for="item in mapGroupApp[group.categoryValue]" :key="item.id" icon="photo-o"
                            :text="item.title" @click="clickApp(item)">
                            <template #icon>
                                <div class="stagingIconContainer" :class="item.theme ? item.theme : 'defaultTheme'">
                                    <van-icon class-prefix="logoIcon" :name="item.icon ? item.icon : defaultLogoIcon"
                                        class="app-staging-icon" :class="logoIconFontFamily" />
                                </div>
                            </template>
                        </van-grid-item>
                    </van-grid>
                    <span
                        v-if="mapGroupApp[group.categoryValue] !== undefined && mapGroupApp[group.categoryValue].length === 0">无</span>
                </van-collapse-item>
            </van-collapse>
        </van-pull-refresh>
    </div>
</template>

<script>
    import {
        Search,
        PullRefresh,
        Collapse,
        CollapseItem,
        Grid,
        GridItem,
        Icon,
        Button
    } from 'vant';
    import {
        getAppCategory,
        getAppList
    } from '@/api/staging'
    import {
        getShortcut
    } from '@/api/application'
    import {
        font_family,
        profix,
        defaultIcon_app
    } from '@/util/LOGO_ICON_CONFIG'
    export default {
        components: {
            vanSearch: Search,
            vanPullRefresh: PullRefresh,
            vanCollapse: Collapse,
            vanCollapseItem: CollapseItem,
            vanGrid: Grid,
            vanGridItem: GridItem,
            vanIcon: Icon,
            vanButton: Button
        },
        data() {
            return {
                logoIconFontFamily: font_family,
                logoIconProfix: profix,
                defaultLogoIcon: defaultIcon_app,
                activeNames: ['default', 'fastEntry'],
                groupList: [],
                mapGroupApp: {},
                wholeLoading: false,
                fastEntryList: [],
                fastEntryShow: false,
            }
        },
        // mounted(){
        //     this.init()
        // },
        methods: {
            // async getfastEntryList(){
            //     let list = await getShortcut()
            //     this.fastEntryList = list.data
            //     if(this.fastEntryList.length > 0){
            //         this.fastEntryShow = true
            //     }else{
            //         this.fastEntryShow = false
            //     }
            // },
            async init() {
                this.wholeLoading = true
                this.mapGroupApp = {}
                try {
                    let list = await getShortcut()
                    this.fastEntryList = list.data
                    if (this.fastEntryList.length > 0) {
                        this.fastEntryShow = true
                    } else {
                        this.fastEntryShow = false
                    }
                    let result = await getAppCategory()
                    this.groupList = result.data.filter(item => item.categoryValue !== '-1');
                    this.setGroupApp()
                } catch (e) {
                    console.error(e)
                } finally {
                    this.wholeLoading = false
                }
            },
            clickFastEntry(config) {
                this.$router.push({
                    path: config.url
                })
            },
            goToSearch() {
                this.$router.push({
                    path: '/search'
                })
            },
            onRefresh() {
                this.groupList = []
                this.mapGroupApp = {}
                this.init()
            },
            async setGroupApp() {
                // if(groupCategoryValue in this.mapGroupApp) return
                let result = await getAppList(null)
                let addList = result.data.records;
                this.mapGroupApp = {}
                addList.forEach(app => {
                    let category = app.category;
                    if (category === null || category === -1) {
                        category = 'default'
                    }
                    if (category in this.mapGroupApp) {
                        this.mapGroupApp[category].push(app)
                    } else {
                        this.mapGroupApp[category] = [app]
                    }
                })

                // this.mapGroupApp[groupCategoryValue] = result.data.records
                this.$forceUpdate()

            },
            collapseChange(activeNames) {
                // let _this = this
                // activeNames.forEach(name => {
                //     // _this.setGroupApp(name)
                // })
            },
            clickApp(appConfig) {
                this.$router.push({
                    path: `/app/${appConfig.id}`
                })
            }
        },
        activated: function (to, from) {
            this.onRefresh()
            // this.init()
        },

    }
</script>

<style scoped lang='less'>
    .cgs-app-staging {
        width: 100%;
        /* height: calc( 100% - 50px ); */
        display: flex;
        flex-direction: column;
    }

    .fastEntryContainer {
        padding: 10px 16px;
    }

    .stagingCollapseRefresh {
        /* height: calc( 100% - 54px ); */
        flex-grow: 1;
        overflow-y: auto;
    }

    .stagingIconContainer {
        height: 50px;
        line-height: 50px;
        width: 50px;
        text-align: center;
        border-radius: 50%;
        // background: red;
        color: #fff;
    }

    .app-staging-icon {
        font-size: 30px;
    }


    .theme1.stagingIconContainer {
        background: rgba(255, 185, 0, 1)
    }

    .theme2.stagingIconContainer {
        background: rgba(255, 140, 0, 1)
    }

    .theme3.stagingIconContainer {
        background: rgba(247, 99, 12, 1)
    }

    .theme4.stagingIconContainer {
        background: rgba(202, 80, 16, 1)
    }

    .theme5.stagingIconContainer {
        background: rgba(218, 59, 1, 1)
    }

    .theme6.stagingIconContainer {
        background: rgba(239, 105, 80, 1)
    }

    .theme7.stagingIconContainer {
        background: rgba(209, 52, 56, 1)
    }

    .theme8.stagingIconContainer {
        background: rgba(255, 67, 67, 1)
    }

    .theme9.stagingIconContainer {
        background: rgba(231, 72, 86, 1)
    }

    .theme10.stagingIconContainer {
        background: rgba(232, 17, 35, 1)
    }

    .theme11.stagingIconContainer {
        background: rgba(234, 0, 94, 1)
    }

    .theme12.stagingIconContainer {
        background: rgba(195, 0, 82, 1)
    }

    .theme13.stagingIconContainer {
        background: rgba(227, 0, 140, 1)
    }

    .theme14.stagingIconContainer {
        background: rgba(191, 0, 119, 1)
    }

    .theme15.stagingIconContainer {
        background: rgba(194, 57, 179, 1)
    }

    .theme16.stagingIconContainer {
        background: rgba(154, 0, 137, 1)
    }

    .theme17.stagingIconContainer {
        background: rgba(0, 120, 215, 1)
    }

    .theme18.stagingIconContainer {
        background: rgba(0, 99, 177, 1)
    }

    .theme19.stagingIconContainer {
        background: rgba(142, 140, 216, 1)
    }

    .theme20.stagingIconContainer {
        background: rgba(107, 105, 214, 1)
    }

    .theme21.stagingIconContainer {
        background: rgba(135, 100, 184, 1)
    }

    .theme22.stagingIconContainer {
        background: rgba(116, 77, 169, 1)
    }

    .theme23.stagingIconContainer {
        background: rgba(177, 70, 194, 1)
    }

    .theme24.stagingIconContainer {
        background: rgba(136, 23, 152, 1)
    }

    .defaultTheme.stagingIconContainer {
        //default
        background: rgba(0, 153, 188, 1)
    }

    .theme26.stagingIconContainer {
        background: rgba(45, 125, 154, 1)
    }

    .theme27.stagingIconContainer {
        background: rgba(0, 183, 195, 1)
    }

    .theme28.stagingIconContainer {
        background: rgba(3, 131, 135, 1)
    }

    .theme29.stagingIconContainer {
        background: rgba(0, 178, 148, 1)
    }

    .theme30.stagingIconContainer {
        background: rgba(1, 133, 116, 1)
    }

    .theme31.stagingIconContainer {
        background: rgba(0, 204, 106, 1)
    }

    .theme32.stagingIconContainer {
        background: rgba(16, 137, 62, 1)
    }

    .theme33.stagingIconContainer {
        background: rgba(122, 117, 116, 1)
    }

    .theme34.stagingIconContainer {
        background: rgba(93, 90, 88, 1)
    }

    .theme35.stagingIconContainer {
        background: rgba(104, 118, 138, 1)
    }

    .theme36.stagingIconContainer {
        background: rgba(81, 92, 107, 1)
    }

    .theme37.stagingIconContainer {
        background: rgba(86, 124, 115, 1)
    }

    .theme38.stagingIconContainer {
        background: rgba(72, 104, 96, 1)
    }

    .theme39.stagingIconContainer {
        background: rgba(73, 130, 5, 1)
    }

    .theme40.stagingIconContainer {
        background: rgba(16, 124, 16, 1)
    }

    .theme41.stagingIconContainer {
        background: rgba(118, 118, 118, 1)
    }

    .theme42.stagingIconContainer {
        background: rgba(76, 74, 72, 1)
    }

    .theme43.stagingIconContainer {
        background: rgba(105, 121, 126, 1)
    }

    .theme44.stagingIconContainer {
        background: rgba(74, 84, 89, 1)
    }

    .theme45.stagingIconContainer {
        background: rgba(100, 124, 100, 1)
    }

    .theme46.stagingIconContainer {
        background: rgba(82, 94, 84, 1)
    }

    .theme47.stagingIconContainer {
        background: rgba(132, 117, 69, 1)
    }

    .theme48.stagingIconContainer {
        background: rgba(126, 115, 95, 1)
    }
</style>
<style>
    .stagingCollapse .van-grid-item__text {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
        text-align: center;
    }

    .stagingCollapse .van-cell::after {
        border-bottom: unset;
    }

    .cgs-app-staging .van-grid-item__content {
        padding: unset;
    }
</style>